import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { colors } from '../config';

const overlayPortalStyle = css({
  position: 'absolute',
  height: '80%',
  width: '100%',
  marginTop: 80, // Top bar height
  background: colors.neutralColors.white,
});

const OverlayPortal = ({ children }) => {
  const overlayPortalRootDiv = document.getElementById('overlay');
  const overlayElement = document.createElement('div');

  useEffect(() => {
    if (overlayPortalRootDiv && overlayElement) {
      overlayPortalRootDiv.appendChild(overlayElement);
    }
    return () => {
      if (overlayElement) {
        overlayPortalRootDiv.removeChild(overlayElement);
      }
    };
  }, [overlayElement, overlayPortalRootDiv]);

  return createPortal(
    <div css={overlayPortalStyle}>{children}</div>,
    overlayElement
  );
};

OverlayPortal.propTypes = {
  children: PropTypes.node.isRequired,
};

export { OverlayPortal };
